export const labels = {
	'en': {
		pageTitle: 'Market Quotes',
	},
	'zh-hans': {
		pageTitle: '市场行情',
	}
};
